var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59 5a.837.837 0 0 0 .581-.245l3.791-3.578a.646.646 0 0 0 .205-.484A.648.648 0 0 0 8.953.2a.735.735 0 0 0-.521-.2c-.2 0-.38.072-.537.215l-3.548 3.37h.486L1.278.214A.777.777 0 0 0 .742 0a.743.743 0 0 0-.528.2A.648.648 0 0 0 0 .693c0 .187.07.348.211.484l3.79 3.578A.84.84 0 0 0 4.59 5Z",
    fill: "#333"
  })));
};

export default SvgArrowDown;